module.exports = __webpack_public_path__ + "components/flag/static/square/ml-966513dd70f0364c2d0d4b4bcecbf55b.svg";